<template>
  <a @click="modal" class="pointer position-relative">
    <BirthdaySvg/>
    <span class="notification-bubble" v-if="birthdaysCounter > 0">
      {{ birthdaysCounter }}
    </span>
  </a>
</template>

<script setup>
import BirthdaySvg from '@/assets/svg-vue/header/birthday.svg'
import {computed, getCurrentInstance} from "vue"
import {useStore} from "vuex"

const store = useStore()
const instance = getCurrentInstance()

const headerCounters = computed(() => store.state.auth.headerCounters)
const birthdaysCounter = computed(() => headerCounters.value.birthdays)

const modal = () => {
  instance?.proxy?.$bvModal?.show('happy-birthday-modal')
}
</script>

<style scoped>
.notification-bubble {
  top: 0;
  right: 8px;
}
</style>
